const moment = require('moment-timezone');

const FY = (d) => d.getFullYear();
const FM = (d) => d.getMonth() + 1;
const FD = (d) => d.getDate();

export const dateSort = (list) => {
    return list.sort(function (a, b) {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(a.date) - new Date(b.date);
    });
};
//return yyyy-mm-dd for passed date
export const getDate = (d) =>
    `${FY(d)}-${FM(d) < 10 ? '0' : ''}${FM(d)}-${FD(d)}`;

export const getDateDMY = (d) => `${FD(d)}-${FM(d)}-${FY(d)}`;

// returns yyyy-mm-dd for current date
export const getCurrentDate = () => getDate(new Date());

// returns yyyy-mm-dd for prev week
export const weekOldDate = (n = 1) => {
    const d = new Date();
    d.setDate(FD(d) - 7 * n);
    return getDate(d);
};

export const monthOldDate = (n = 1) => {
    const d = new Date();
    d.setMonth(FM(d) - n - 1);
    return getDate(d);
};

export const yearOldDate = (n = 1) => {
    const d = new Date();
    d.setFullYear(FY(d) - n);
    return getDate(d);
};

export const getReadableDate = (d) => {
    if (d && !d.includes('T')) {
        // Fix for iOS
        d = d.split(' ').join('T');
    }
    const dateObject = new Date(d);
    var month = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];
    return `${FD(dateObject)} ${month[FM(dateObject) - 1]} ${FY(dateObject)}`;
};

export const getReadableTime = (dt) => {
    const f = 'HH:mm:ss';
    return getDateInLocal(dt, false, false, f);
};

export const getWelcomeText = () => {
    const x = new Date();
    let hours = x.getUTCHours() + 8;
    if (hours > 23) {
        hours = hours - 23;
    }
    if (hours > 4 && hours < 12) {
        return 'Good Morning';
    } else if (hours >= 12 && hours < 16) {
        return 'Good Afternoon';
    }
    // else if (hours >= 16 && hours < 20) {
    // 	return 'Evening';
    // }
    return 'Good Evening';
};

export const getAsiaSingaporeDate = (dt) => {
    let mt = moment(dt);
    mt = mt.tz('Asia/Singapore').utc().format('DD MMM YYYY');
    return dt ? mt : '';
};

export const getDateInLocal = (
    dt,
    onlyDate = false,
    momentObj = false,
    format,
) => {
    if (!dt) return '';
    let mt = moment.utc(dt, 'YYYY-MM-DD HH:mm:ss').local();
    return momentObj
        ? mt
        : mt.format(
              format
                  ? format
                  : onlyDate
                  ? 'DD MMM YYYY'
                  : 'DD MMM YYYY | HH:mm',
          );
};

export const getRelativeTime = (date, local = true) => {
    if (!date) {
        return null;
    }
    return local
        ? getDateInLocal(date, false, true).fromNow()
        : moment(date).fromNow();
};
